import { Component } from 'react';
import { connect } from "react-redux";
import UserViewRow from "./UserViewRow";
import PageBanner from "../common/page/PageBanner";
import EmailAddressSelectionList from '../common/selection/EmailAddressSelectionList';
import PhoneNumberSelectionList from '../common/selection/PhoneNumberSelectionList';
import { bellIconHollow } from "../../img/font_awesome/font_awesome"
import { Button, Col, Container, Row, Modal } from 'react-bootstrap'
import axios from "axios";
import configData from "../../config/config.json";
import { lookupAlert } from "../../redux/actions/alertActions.js";
import translations from "../../config/translation/home_translations.json"

import { LOADING_STATUES } from "../constants/constants";
import Loading from '../common/modal/Loading';

const mapStateToProps = state => {
  return {
    currentUser: state.currentUserReducer,
    language: state.languageReducer ? state.languageReducer : 'ENGLISH'
  };
}

const matchDispatchToProps = (dispatch) => {
  return {
    selectAlert: (alertId, callback) => dispatch(lookupAlert(alertId, callback))
  }
}

class UserView extends Component {

  state = {
    filteredList: [],
    statusType: 'ALL',
    filterText: '',
    emailAddressId: '',
    emailAddressName: '',
    phoneNumberId: '',
    phoneNumberName: '',
    showEmailAddressList: false,
    showPhoneNumberList: false,
    loadingStatus: ""
  }

  showLoading = () => {
    if (this.state.loadingStatus === "") {
      this.setState({
        loadingStatus: LOADING_STATUES.LOADING
      })
      return true;
    }
    return false;
  }

  handleEditRow = (event) => {
    event.preventDefault();
    const id = event.target.closest("fieldset").id;
    if (this.showLoading()) {
      this.props.selectAlert(id, this.handleOpenAlertEntryCallBack);
    }
  }

  handleOpenAlertEntryCallBack = (message) => {
    this.setState({
      loadingStatus: "",
      submitMessage: ""
    });

    this.props.handleOpenAlertEntry();
  }

  hideLoading = (message, status) => {
    if (status === 'ERROR') {
      this.setState({
        loadingStatus: "",
        submitMessage: ""
      })
    } else {
      this.setState({
        loadingStatus: "",
        submitMessage: message
      })
    }
  }

  handleFilter = () => {
    if (this.showLoading() !== true) {
      return;
    }

    let filters = { filterText: this.state.filterText, statusType: this.state.statusType, emailAddressId: this.state.emailAddressId, phoneNumberId: this.state.phoneNumberId };
    axios.post(configData.LANDNOTIFICATION_SERVER_URL + "userView/alerts", filters, { withCredentials: true })
      .then((response) => {
        this.setState({ filteredList: response.data.content.alerts, loadingStatus: '' })
      }, (error) => {
        // this.setState({ status: '' }, this.showWarning(error.response.data.message));
      });
  }

  handleCloseClick = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.setState({ errors: {} })
    this.props.handleClose();
  }

  handleCloseEmailAddressLookup = (selectedId, selectedName) => {
    this.setState({
      phoneNumberId: 0,
      showEmailAddressList: false,
      emailAddressId: selectedId,
      emailAddressName: selectedName
    }, function () { this.handleFilter() });
  }

  handleEmailAddressFinderFilterClick = () => {
    this.setState({
      showEmailAddressList: true
    });
  }

  handleEmailAddressFinderFilterReset = () => {
    this.setState({ emailAddressId: 0 }, function () { this.handleFilter() })
  }

  handleClosePhoneNumberLookup = (selectedId, selectedName) => {
    this.setState({
      emailAddressId: 0,
      showPhoneNumberList: false,
      phoneNumberId: selectedId,
      phoneNumberName: selectedName
    }, function () { this.handleFilter() });
  }

  handlePhoneNumberFinderFilterClick = () => {
    this.setState({
      showPhoneNumberList: true
    });
  }

  handlePhoneNumberFinderFilterReset = () => {
    this.setState({ phoneNumberId: 0 }, function () { this.handleFilter() })
  }

  handleTextFilter = (filterText) => {
    this.setState({ filterText: filterText }, function () { this.handleFilter() })
  }

  handleTextFilterReset = () => {
    this.setState({ filterText: '' }, function () { this.handleFilter() })
  }

  handleSelectFilter = (filterSelected) => {
    this.setState({ statusType: filterSelected }, function () { this.handleFilter() })
  }

  openNewAlertEntry = (event) => {
    event.preventDefault();
    this.props.handleNewAlertEntry();
  }

  componentDidMount() {
    this.handleFilter();
  }

  render() {

    const textFilterProps = {
      textFilter: this.handleTextFilter,
      textFilterReset: this.handleTextFilterReset,
      filterText: this.state.filterText
    }

    const emailAddressFinderFilterProps = {
      finderFilterClick: this.handleEmailAddressFinderFilterClick,
      finderFilterReset: this.handleEmailAddressFinderFilterReset,
      name: this.state.emailAddressName,
      id: this.state.emailAddressId
    }

    const phoneNumberFinderFilterProps = {
      finderFilterClick: this.handlePhoneNumberFinderFilterClick,
      finderFilterReset: this.handlePhoneNumberFinderFilterReset,
      name: this.state.phoneNumberName,
      id: this.state.phoneNumberId
    }

    return (
      <>
        <Modal show={this.props.show} onHide={this.handleCloseClick} size="lg" centered>
          <Modal.Header style={{ background: '#145A7B', color: 'white' }}>
            <Modal.Title>{bellIconHollow}&nbsp;&nbsp;{translations[this.props.language].my_alerts}</Modal.Title>
            <span style={{ textAlign: 'right' }}><Button variant="link" id='userViewClose' style={{textDecoration: 'none'}} onClick={this.handleCloseClick} aria-label='Close'>&#x2716;</Button></span>
          </Modal.Header>
          <Modal.Body>
            <Container style={{ marginTop: 0, marginBottom: 10, paddingTop: 0, paddingBottom: 10 }}>
              <Row>
                <Col style={{ marginTop: 0, marginBottom: 16, textAlign: 'right' }}><Button className='btn-primary' onClick={this.openNewAlertEntry}>{translations[this.props.language].add_new_alert}</Button></Col>
              </Row>

              <Row>
                <Col><hr style={{ border: 'none', height: 5, marginTop: 0, backgroundColor: 'darkgray' }}></hr></Col>
              </Row>
              <PageBanner pageHeading='' textFilterProps={textFilterProps} finderFilterProps={emailAddressFinderFilterProps} finderFilterProps2={phoneNumberFinderFilterProps} buttons={[]} />
              {
                this.state.filteredList.map((alertResult, index) => {
                  return (
                    <UserViewRow key={index} id={alertResult.id} alertName={alertResult.name} alertType={alertResult.criteriaType} alertKey={alertResult.criteria} emailAddressDTOs={alertResult.emailAddressDTOs} emailAddresses={alertResult.emails} onClick={this.handleEditRow} phoneDTOs={alertResult.phoneDTOs} phoneNumbers={alertResult.phones}></UserViewRow>
                  )
                })
              }
            </Container>
          </Modal.Body>
        </Modal>
        <Loading loadingIndicator={this.state.loadingStatus === LOADING_STATUES.LOADING} />
        <EmailAddressSelectionList userId={this.props.currentUser.userId} showModal={this.state.showEmailAddressList} onHide={(selectedId, selectedName) => this.handleCloseEmailAddressLookup(selectedId, selectedName)} />
        <PhoneNumberSelectionList userId={this.props.currentUser.userId} showModal={this.state.showPhoneNumberList} onHide={(selectedId, selectedName) => this.handleClosePhoneNumberLookup(selectedId, selectedName)} />
       </>
    )
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(UserView);